import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class BookAppointment extends Page{
    constructor(){
        super({
            id : 'book_appointment',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}